import React from "react";
import { Card as CardType, SUIT_SYMBOLS, RANK_NAMES, isRedSuit } from "./Deck";

interface CardProps {
  card?: CardType;
  faceDown?: boolean;
  size?: "sm" | "md" | "lg";
  onClick?: () => void;
  selected?: boolean;
  dimmed?: boolean;
  placeholder?: boolean;
}

const SIZE_STYLES: Record<string, React.CSSProperties> = {
  sm: { width: 40, height: 56, fontSize: 12 },
  md: { width: 56, height: 80, fontSize: 18 },
  lg: { width: 72, height: 100, fontSize: 22 },
};

const CardView: React.FC<CardProps> = ({
  card,
  faceDown = false,
  size = "md",
  onClick,
  selected = false,
  dimmed = false,
  placeholder = false,
}) => {
  const sizeStyle = SIZE_STYLES[size];

  if (placeholder && !card) {
    return (
      <div
        style={sizeStyle}
        className={`rounded-lg border-2 border-dashed border-gray-500 bg-gray-800/30
          flex items-center justify-center select-none
          ${
            onClick
              ? "cursor-pointer hover:border-gray-300 transition-colors"
              : ""
          }`}
        onClick={onClick}
      >
        <span className="text-gray-500 text-lg">+</span>
      </div>
    );
  }

  if (faceDown || !card) {
    return (
      <div
        style={sizeStyle}
        className={`rounded-lg border-2 border-gray-600
          bg-gradient-to-br from-blue-800 to-blue-950 shadow-md
          flex items-center justify-center select-none
          ${
            onClick ? "cursor-pointer hover:scale-105 transition-transform" : ""
          }`}
        onClick={onClick}
      >
        <span className="text-blue-400/40 text-2xl">♠</span>
      </div>
    );
  }

  const red = isRedSuit(card.suit);
  const symbol = SUIT_SYMBOLS[card.suit];
  const rank = RANK_NAMES[card.rank];

  return (
    <div
      style={sizeStyle}
      className={`rounded-lg border shadow-md
        flex flex-col items-center justify-between select-none
        transition-all duration-150
        ${red ? "text-red-600" : "text-gray-900"}
        ${
          selected
            ? "border-amber-400 border-2 ring-2 ring-amber-400/50 bg-amber-50"
            : "border-gray-300 bg-white"
        }
        ${dimmed ? "opacity-40" : ""}
        ${
          onClick
            ? "cursor-pointer hover:scale-105 hover:shadow-lg active:scale-95"
            : ""
        }`}
      onClick={onClick}
    >
      <div
        className="self-start leading-none font-bold pl-1 pt-0.5"
        style={{ fontSize: sizeStyle.fontSize }}
      >
        {rank}
      </div>
      <div
        className="leading-none"
        style={{ fontSize: (sizeStyle.fontSize as number) * 1.3 }}
      >
        {symbol}
      </div>
      <div
        className="self-end leading-none font-bold pr-1 pb-0.5 rotate-180"
        style={{ fontSize: sizeStyle.fontSize }}
      >
        {rank}
      </div>
    </div>
  );
};

export default CardView;
